/* Voyanta cart guard - re-checks the cart and toggles the no-trolley banner. */
(function () {
  var el = document.querySelector('[data-vb-cart-guard]');
  if (!el) return;
  var trolleySku = el.getAttribute('data-trolley-sku');
  var trolleyHandle = el.getAttribute('data-trolley-handle');
  var kitsHandle = el.getAttribute('data-kits-handle');

  function recheck() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hasTrolley = false, hasKit = false;
        (cart.items || []).forEach(function (i) {
          if (i.sku === trolleySku) hasTrolley = true;
          if (i.handle === kitsHandle) hasKit = true;
          else if (i.handle === trolleyHandle && i.sku !== trolleySku) hasKit = true;
        });
        el.hidden = !(hasKit && !hasTrolley);
      }).catch(function () {});
  }

  document.addEventListener('click', function () { setTimeout(recheck, 700); });
  window.addEventListener('pageshow', recheck);
})();
